import React, { useId, useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  RadioGroup,
  RadioGroupItem,
  Label,
} from '@roger/ui-components';

export type AdoptionReportExportFormat = 'csv' | 'xlsx';

export interface AdoptionReportExportFormatDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (format: AdoptionReportExportFormat) => void;
}

export const AdoptionReportExportFormatDialog: React.FC<
  AdoptionReportExportFormatDialogProps
> = ({ open, onOpenChange, onConfirm }) => {
  const idPrefix = useId();
  const [exportFormat, setExportFormat] =
    useState<AdoptionReportExportFormat>('xlsx');

  const xlsxId = `${idPrefix}-xlsx`;
  const csvId = `${idPrefix}-csv`;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Export adoption report</DialogTitle>
        </DialogHeader>
        <div className='space-y-4'>
          <p className='text-sm text-muted-foreground'>
            Choose the file format you want to export.
          </p>
          <RadioGroup
            value={exportFormat}
            onValueChange={value =>
              setExportFormat(value === 'xlsx' ? 'xlsx' : 'csv')
            }
            className='space-y-2'
          >
            <div className='flex items-center space-x-2'>
              <RadioGroupItem value='xlsx' id={xlsxId} />
              <Label htmlFor={xlsxId} className='text-sm'>
                Excel (.xlsx)
              </Label>
            </div>
            <div className='flex items-center space-x-2'>
              <RadioGroupItem value='csv' id={csvId} />
              <Label htmlFor={csvId} className='text-sm'>
                CSV (.csv)
              </Label>
            </div>
          </RadioGroup>
        </div>
        <DialogFooter>
          <Button variant='outline' onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              onOpenChange(false);
              onConfirm(exportFormat);
            }}
          >
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
